import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldExpert, FieldExpertCreateRequest, FieldExpertUpdateRequest } from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FieldExpertsService {
  private readonly url = `${environment.bffUrl}/field-experts`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<FieldExpert[]> {
    return this.http.get<FieldExpert[]>(this.url);
  }

  add(fieldExpert: FieldExpertCreateRequest): Observable<FieldExpert> {
    return this.http.post<FieldExpert>(this.url, fieldExpert);
  }

  update(id: string, fieldExpert: FieldExpertUpdateRequest): Observable<FieldExpert> {
    return this.http.put<FieldExpert>(`${this.url}/${id}`, fieldExpert);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
